/*
    Business logic menu data added during development
    roles: 0: Registered user:, 1:administrators, 9:Menu for login page display only
*/
import Layout from "@/layout";
import authentication from "./authentication.js";
import wellManage from "./wellManage.js";
import messages from "./messages.js"
import home from "./home.js"
import annualReview from "./annualReview.js"
import volumeAudit from "./volumeAudit.js"
// import securityDeposit from "./securityDeposit.js"
import Rep from "./Rep.js"
import expenseMansgement from "./expenseMansgement.js"

const fmMenuRoutes = [
  {
    path: '',
    component: Layout,
    redirect: 'index',
    meta: {
      title: "Home Page",
      icon: "tn-daiban",
    },
    children: [
      ...home
    ],
  },
  // {
  //   path: "/authentication",
  //   alwaysShow: false,
  //   name: "ProducerAuthentication",
  //   redirect: "noRedirect",
  //   component: Layout,
  //   meta: {
  //     title: "Producer Authentication",
  //     icon: "tn-nav-producer",
  //   },
  //   children: [...authentication],
  // },
  {
    path: "/wellManagement",
    alwaysShow: false,
    name: "WellManagement",
    redirect: "noRedirect",
    component: Layout,
    meta: {
      title: "Well Management",
      icon: "tn-nav-well",
    },
    children: [...wellManage],
  },
  {
    path: "/VolumeAudit",
    alwaysShow: false,
    name: "VolumeAudit",
    redirect: "noRedirect",
    component: Layout,
    meta: {
      title: "Volume",
      icon: "tn-volume",
    },
    children: [...volumeAudit],
  },
  // {
  //   path: "/SecurityDeposit",
  //   alwaysShow: false,
  //   name: "SecurityDeposit",
  //   redirect: "noRedirect",
  //   component: Layout,
  //   meta: {
  //     title: "Volume Audit",
  //     icon: "tn-nav-well",
  //   },
  //   children: [...securityDeposit],
  // },
  {
    path: "/expenseMansgement",
    alwaysShow: false,
    name: "ExpenseMansgement",
    redirect: "noRedirect",
    component: Layout,
    meta: {
      title: "Expense Mansgement",
      icon: "tn-expense",
    },
    children: [...expenseMansgement],
  },
  {
    path: "/Rep",
    alwaysShow: false,
    name: "Rep",
    redirect: "noRedirect",
    component: Layout,
    meta: {
      title: "Rep Detailed",
      icon: "tn-tat",
    },
    children: [...Rep],
  },
  {
    path: "/annualReview",
    alwaysShow: false,
    name: "AnnualReview",
    redirect: "noRedirect",
    component: Layout,
    meta: {
      title: "Annual Review",
      icon: "tn-nav-annual",
    },
    children: [...annualReview],
  },
  {
    path: "/messages",
    alwaysShow: false,
    name: "Messages",
    redirect: "noRedirect",
    component: Layout,
    meta: {
      title: "Messages",
      icon: "tn-nav-message",
    },
    children: [...messages],
  },
];
export default fmMenuRoutes;
